module.exports = __webpack_public_path__ + "static/media/a2Hosting.50fe14d2.webp";